import { Typographies } from '@/theme';
import { Box, Card, Typography, styled } from '@mui/material';

export const CandidatesTitle = styled(Typography)(({ theme }) => ({
  textAlign: 'center',
  fontSize: theme.typography.pxToRem(24),
  fontWeight: Typographies.FONT_WEIGHT_H2,
  lineHeight: '36px',
  marginTop: theme.spacing(3.5),
  marginBottom: '38px',
  color: theme.palette.primary.main,
  marginLeft: 'auto',
  marginRight: 'auto',
  overflow: 'unset',
}));

export const CandidateLabel = styled(Typography)(({ theme }) => ({
  color: '#1D1D1D',
  fontFeatureSettings: "'clig' off, 'liga' off",
  fontFamily: 'Inter',
  fontSize: '16px',
  fontStyle: 'normal',
  fontWeight: '700',
  lineHeight: '24px',
}));

export const CandidateLabelPhone = styled(Typography)(({ theme }) => ({
  color: '#1D1D1D',
  fontFeatureSettings: "'clig' off, 'liga' off",
  fontFamily: 'Inter',
  fontSize: '16px',
  fontStyle: 'normal',
  fontWeight: '400',
  lineHeight: '24px',
}));

export const Circle = styled(Box)(({ theme }) => ({
  width: '48px',
  height: '48px',
  borderRadius: '48px',
  border: '1px solid rgba(102, 43, 92, 0.32)',
  background: '#FFF7FC',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

export const CardCandidate = styled(Card)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: '16px',
  paddingLeft: '16px',
  paddingTop: '16px',
  paddingRight: '16px',
  paddingBottom: '16px',
  backgroundColor: '#F7EDF4',
}));

export const TitleExistCv = styled(Typography)(() => ({
  color: '#662B5C',
  textAlign: 'right',
  fontFamily: 'Inter',
  fontSize: '14px',
  fontStyle: 'normal',
  fontWeight: '600',
  lineHeight: '20px',
}));

export const ContainerCvVideoTitle = styled(Box)(() => ({
  borderRadius: '4px',
  paddingInline: '12px',
  border: '1px solid rgba(102, 43, 92, 0.48)',
  background: 'rgba(237, 194, 226, 0.56)',
}));
